import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {ProleisObject} from 'proleis-rest-client';

@Component({
  selector: 'p4m-additional-tracking',
  templateUrl: 'additional.tracking.component.html',
})
export class AdditionalTrackingComponent implements OnInit {
  @Input()
  formGroup: FormGroup;

  @Input()
  activities: ProleisObject[];

  @Input()
  positions: ProleisObject[];

  @Input()
  serviceTypes: ProleisObject[];

  @Input()
  ratingTypes: ProleisObject[];

  @Output()
  ratingTypeChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}

  onRatingTypeChanged() {
    this.ratingTypeChanged.emit(true);
  }

  getErrorMessage(control: AbstractControl, fieldName: string): string | null {
    if (!control || !control.errors || control.pending) {
      return null;
    }
    console.log(control.status)
    return control.errors[fieldName]?.errorMessage;
  }
}
